import { render, staticRenderFns } from "./chateau-larrivet-haut-brion.vue?vue&type=template&id=61cc52f0&scoped=true"
import script from "./chateau-larrivet-haut-brion.vue?vue&type=script&lang=js"
export * from "./chateau-larrivet-haut-brion.vue?vue&type=script&lang=js"
import style0 from "./chateau-larrivet-haut-brion.vue?vue&type=style&index=0&id=61cc52f0&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "61cc52f0",
  null
  
)

export default component.exports